export default {
  about: {
    hero: {
      eyebrow: 'Über uns',
      title: 'Persönlich. Professionell. Präzise.',
      lead: '{{name}} steht für individuell geplante Videoüberwachung und persönliche Betreuung aus einer Hand.',
    },
    story: {
      quote: '„Statt vorgefertigte Pakete zu verkaufen, wird jedes Objekt nach seinem tatsächlichen Bedarf betrachtet – von den gewünschten Bildbereichen über die Montagepunkte bis zur Aufzeichnung und App-Einrichtung.“',
      p1: '{{name}} wird geleitet von {{owner}} – Ihrem persönlichen Ansprechpartner von der ersten Beratung bis zur laufenden Betreuung. Seit über 20 Jahren ist er in der Sicherheitstechnik tätig und hat in dieser Zeit hunderte Projekte für Privat- und Gewerbekunden realisiert.',
      p2: 'Die langjährige Erfahrung umfasst die Planung und Installation von Kamerasystemen in Einfamilienhäusern, Mehrfamilienhäusern, Einzelhandelsgeschäften, Büros, Praxen, Gastronomiebetrieben, Lagerhallen, Werkstätten und Produktionsflächen. Jedes Projekt wird individuell betrachtet – denn kein Objekt ist wie das andere.',
      p3: 'Je nach Projektanforderung setzt {{name}} unter anderem auf bewährte Systeme von Hikvision und Safire. Auch Lösungen weiterer namhafter Hersteller können individuell geplant und beschafft werden.',
      p4: '{{name}} versteht sich nicht als reiner Verkäufer, sondern als langfristiger Partner. Nach der Installation bleibt der persönliche Kontakt erhalten – für Fragen, Wartung, Erweiterungen oder einfach nur, um sicherzugehen, dass alles funktioniert.',
    },
    owner: {
      subtitle: 'Sicherheitstechnik aus Hainburg',
      photoPlaceholder: 'Inhaberfoto folgt in Kürze',
      role: 'Inhaber & Ansprechpartner',
    },
    milestonesTitle: 'Erfahrung, die sich bemerkbar macht',
    milestones: {
      '0': { year: 'Seit über 20 Jahren', desc: 'Erfahrung in der Planung und Installation von Kamerasystemen für Privat- und Gewerbekunden in der Region Rhein-Main.' },
      '1': { year: 'Hunderte realisierte Projekte', desc: 'Vom Einfamilienhaus über Ladenflächen bis zu großen Gewerbeanlagen – jedes Projekt individuell geplant.' },
      '2': { year: 'Herstellerunabhängig', desc: 'Wir wählen die passende Technik für Ihre Anforderungen, projektabhängig von verschiedenen namhaften Herstellern.' },
    },
    valuesTitle: 'Das macht {{name}} aus',
    values: {
      '0': { title: 'Individuelle Planung', desc: 'Keine vorgefertigten Pakete. Jedes Objekt wird nach seinem tatsächlichen Bedarf betrachtet.' },
      '1': { title: 'Fachgerechte Umsetzung', desc: 'Saubere Installation, korrekte Ausrichtung und professionelle Verkabelung.' },
      '2': { title: 'Digitale Anbindung', desc: 'Smartphone-App, Fernzugriff und Benachrichtigungen – eingerichtet und erklärt.' },
      '3': { title: 'Persönliche Betreuung', desc: 'Ein Ansprechpartner. Vertraut. Zuverlässig. Auch nach der Installation.' },
    },
    cta: {
      title: 'Lernen Sie uns kennen',
      lead: 'Ein unverbindliches Erstgespräch zeigt schnell, ob wir zusammenpassen. Wir freuen uns darauf, Ihr Projekt kennenzulernen.',
      primary: 'Termin vereinbaren',
      secondary: 'Häufige Fragen',
    },
  },
};